export enum RoleEnum {
  ADMIN = '00001',
  STUDENT = '00002',
  TEACHER = '00003',
}

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  AUDIO = 'AUDIO',
  FILE = 'FILE',
  EMOTION = 'EMOTION',
  LOCATION = 'LOCATION',
}

export enum FileTypeExtEnum {
  PNG = 'image/png',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  GIF = 'image/gif',
}

export enum ContentTypeEnum {
  FORM_DATA = 'multipart/form-data',
  JSON = 'application/json',
}

export enum ReadStateTypeEnum {
  READ = 'read',
  UNREAD = 'unread',
}

export enum MaterialTypeEnum {
  FILE = 'File',
  EXTERNAL_URL = 'ExternalUrl',
  EXTERNAL_TOOL = 'ExternalTool',
  QUIZ = 'Quiz',
}

export enum QuizTypeEnum {
  ASSIGNMENT = 'assignment',
  PRACTICE_QUIZ = 'practice_quiz',
  GRADED_SURVEY = 'graded_survey',
  SURVEY = 'survey',
}

export enum QuizScoringPolicyTypeEnum {
  HIGHEST = 'keep_highest',
  LATEST = 'keep_latest',
  AVERAGE = 'keep_average',
}

export enum QuizSubmissionWorkflowStateTypeEnum {
  UN_TAKEN = 'untaken',
  COMPLETE = 'complete',
}

export enum ToastTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export enum QuizQuestionTypeEnum {
  CALCULATED = 'calculated_question',
  ESSAY = 'essay_question',
  FILE_UPLOAD = 'file_upload_question',
  FILL_IN_MULTIPLE_BLANKS = 'fill_in_multiple_blanks_question',
  MATCHING = 'matching_question',
  MULTIPLE_ANSWERS = 'multiple_answers_question',
  MULTIPLE_CHOICE = 'multiple_choice_question',
  MULTIPLE_DROPDOWNS = 'multiple_dropdowns_question',
  NUMERICAL = 'numerical_question',
  SHORT_ANSWER = 'short_answer_question',
  TEXT_ONLY = 'text_only_question',
  TRUE_FALSE = 'true_false_question',
}

export enum IActivityReportTypeEnum {
  DISCUSSION = 'DISCUSSION',
  QUIZ = 'QUIZ',
  LESSON = 'LESSON',
}

export enum IReportTypeEnum {
  ACTIVITY = 'ACTIVITY',
  NORMAL = 'NORMAL',
}

export enum LessonStatusFilterEnum {
  ALL = 'all',
  WATCHED = 'watched',
  UNWATCHED = 'unwatched',
}

export enum LessonTypeFilterEnum {
  ALL = 'all',
  DISCUSSION_FORUM = 'discussion_forum',
  MIDTERM_EXAM = 'midterm_exam',
  FINAL_EXAM = 'final_exam',
  LESSON = 'lesson',
}
